import React, { forwardRef } from 'react';

import AddIcon from '@material-ui/icons/Add';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import Delete from '@material-ui/icons/Delete';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';

export default {
  Add: forwardRef((props, ref) => (
    <AddIcon {...props} ref={ref} color="action" />
  )),
  Check: forwardRef((props, ref) => (
    <Check {...props} ref={ref} color="action" />
  )),
  Clear: forwardRef((props, ref) => (
    <Clear {...props} ref={ref} color="action" />
  )),
  Delete: forwardRef((props, ref) => (
    <Delete {...props} ref={ref} color="action" />
  )),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} color="action" />
  )),
  Edit: forwardRef((props, ref) => (
    <Edit {...props} ref={ref} color="action" />
  )),
  Export: forwardRef((props, ref) => (
    <SaveAlt {...props} ref={ref} color="action" />
  )),
  Filter: forwardRef((props, ref) => (
    <FilterList {...props} ref={ref} color="action" />
  )),
  FirstPage: forwardRef((props, ref) => (
    <FirstPage {...props} ref={ref} color="action" />
  )),
  LastPage: forwardRef((props, ref) => (
    <LastPage {...props} ref={ref} color="action" />
  )),
  NextPage: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} color="action" />
  )),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} color="action" />
  )),
  ResetSearch: forwardRef((props, ref) => (
    <Clear {...props} ref={ref} color="action" />
  )),
  Search: forwardRef((props, ref) => (
    <Search {...props} ref={ref} color="action" />
  )),
  SortArrow: forwardRef((props, ref) => (
    <ArrowDownward {...props} ref={ref} color="action" />
  )),
  ThirdStateCheck: forwardRef((props, ref) => (
    <Remove {...props} ref={ref} color="action" />
  )),
  ViewColumn: forwardRef((props, ref) => (
    <ViewColumn {...props} ref={ref} color="action" />
  )),
};
